'use client'

import { useEffect, useState } from 'react'
import { LivePreviewListener } from '@onclicks/sharedcomponents/LivePreviewListener'

export function DraftModeListener() {
  const [isDraft, setIsDraft] = useState(false)

  useEffect(() => {
    setIsDraft(document.cookie.includes('__prerender_bypass'))
  }, [])

  if (!isDraft) return null
  return <LivePreviewListener />
}
